import type { PropsWithChildren } from 'react'

import styles from './styles.module.css'

export const WalletDetailSections = ({ children }: PropsWithChildren) => (
  <div className={styles.stack} data-wallet-detail>
    {children}
  </div>
)
